
































import _ from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { editFactory } from '@/main/pages';
import { openRouteAndReplace } from '@/main/router/routerPath';

import { MERGE, NAME, PARTNER_MERGE, MERGE_PROPS } from './constants';
import { store } from './store/merge';
import { mergeActions } from './store/types';

export default editFactory(PARTNER_MERGE, store).extend({
	data() {
		return {
			updateMergeTable: false,
			dependencies: {
				[MERGE]: MERGE,
			},
			mergeProps: MERGE_PROPS,
			tableKeysIndex: {
				LABEL_INDEX: 1,
				SOURCE_NAME_INDEX: 2,
				DUPLICATE_NAME_INDEX: 3,
				LABEL_NAME_INDEX: 5,
			},
		};
	},
	computed: {
		similarItems(): any {
			return this.parentUri && this.$store.state.pages[this.parentUri.split('/')[1]].dependentTables
				? this.$store.state.pages[this.parentUri.split('/')[1]].dependentTables.MergeZakaznik
				: null;
		},
		IsFirma() : boolean {
			return this.PartnertypPzn === 2;
		},
	},
	methods: {
		updateKVZ(record: object) {
			return openRouteAndReplace(NAME, PageMode.EDIT, { props: true, id: this.ZakaznikId!, updateData: record, fromMerge: true, destroy: 'no' });
		},
		createKVZ(record: object) {
			return openRouteAndReplace(NAME, PageMode.CREATE, { props: true, updateData: record, fromMerge: true, destroy: 'no' });
		},
		async loadPartner(id : number) {
			if (this.ZakaznikId !== id) {
				this.ZakaznikId = id;
				await this.$store.dispatch(`${this.storeUri}/${mergeActions.GET_PARTNER}`, this.ZakaznikId);
			}
		},
		async loadDependentTableData(id: number | null) {
			this.updateMergeTable = false;
			this.ZakaznikId = id;
			await this.fetchTableData([MERGE]);
			this.updateMergeTable = true;
		},
		async fetchTableData(tablesToFetch : string[]) {
			const dataPromises = (await (tablesToFetch || Object.values(this.dependencies))
				.map((dependency) => this.$store.dispatch(`${this.storeUri}/${MERGE}_${'TABLE_DATA'}`,
					{ filter: _.get(this, `${dependency}Filter`) }))) as Promise<any>[];
			return Promise.all(dataPromises);
		},
		async loadData() {
			this.endLoading();
		},
	},
});
